module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d903f979731e0aa1b305333c87957072.png";